export default __webpack_public_path__ + "static/media/icon-logo.68bc4d98.svg";